import { useAtomValue } from 'jotai';
import { useDispatch, useSelector } from 'react-redux';
import { layoutAtom } from '@src/components/metrics-panel-hz/atoms';
import { intervalSelector } from '@src/store/common/selectors';
import { breadcrumbSelector } from '@src/store/summaryContainer/selectors';
import { createTempDashboard } from '@src/store/tempDashboard/actions';
import { dimensionsSelector } from '@src/store/trends/base/selectors';
import { DASHBOARD_TYPE, isAppModule, USECASE_KEY_WIDGET_DRILLDOWN } from '@src/utils/constants';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';
import apptracker from '@src/utils/sensor/apptracker';
import { WIDGET_DRILLDOWN } from '@src/utils/sensor/track';
import { isAppFlowPresetUsecaseKey, getAppFlowIdFromUsecaseKey } from '@utils/preset';

const useCreateTempDashboard = ({
  filter,
  metrics,
  selectedDimensions,
  selectedMetric,
  selectedUnit,
  title = 'widget dashboard',
  usecaseKey = USECASE_KEY_WIDGET_DRILLDOWN,
  widgetMeta = {} as Record<string, any>,
}) => {
  const dispatch = useDispatch();
  const interval = useSelector(intervalSelector);
  const dimensions = useSelector(dimensionsSelector);
  const breadcrumb = useSelector(breadcrumbSelector);
  const layout = useAtomValue(layoutAtom);

  const createDashboard = () => {
    const config = {
      // usecase key enforces the new drill-down workflow (without injector layer)
      usecaseKey,
      widgetMeta, // add custom meta for drilldown
      metricsChartContainer: {
        metric: getInvertedPercentageMetricByKey({
          metricKey: selectedMetric,
          defaultValue: selectedMetric,
        }),
        metrics,
      },
      common: {
        appliedFilters: [filter],
        interval,
      },
      'module:trends': {
        base: {
          dimensions: selectedDimensions ?? dimensions,
          // globalOrderBy: orderByMetric,
          dimensionMetrics: [metrics],
        },
      },
      summary: {
        drilldownData: [...breadcrumb],
      },
      toggles: {
        sections: {
          summary: false,
        },
      },
      metricPanel: {
        widgetPanelVisibility: false,
        layout,
        unit: selectedUnit,
      },
    };

    const isAppFlow = isAppFlowPresetUsecaseKey(usecaseKey);
    const flowId = isAppFlow ? getAppFlowIdFromUsecaseKey(usecaseKey) : undefined;

    dispatch(
      createTempDashboard(
        isAppModule ? DASHBOARD_TYPE.APP_EXPERIENCE_DRILLDOWN : DASHBOARD_TYPE.TRENDS_DRILLDOWN,
        config,
        title,
        {
          urlSearch: flowId ? { flowId: flowId } : undefined,
        },
      ),
    );

    apptracker(WIDGET_DRILLDOWN, {
      title,
      widgetType: isAppFlow ? 'flow' : undefined,
      flowId,
    });
  };

  return { createDashboard };
};

export default useCreateTempDashboard;
